<template>
  <div>
    <div class="form-row">
      <h3>Manage SCC User Account List</h3>
    </div>
    <div class="e-card">
      <div id="sccActiveUsers">
        <div style="text-align: left; padding-bottom: 1px">
          <ejs-button type="button" cssClass="e-info" v-on:click.native="onAddNewSCCUserClick">
            <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" /> Add New User
          </ejs-button>
        </div>
        <ejs-grid
          :dataSource="sccUserList"
          ref="refSCCActiveUserList"
          :created="created"
          enablePersistence="true"
          :selection-settings="selectionOptions"
          :commandClick="activeUserCommandClick"
          :allowSorting="true"
          :allowPaging="true"
          :pageSettings="activeUserpageSettings"
          :toolbar="toolbarOptions"
        >
          <e-columns>
            <e-column
              field="userId"
              headerText="User ID"
              textAlign="Left"
              :isPrimaryKey="true"
              width="0"
            ></e-column>
            <e-column headerText="Edit" :commands="commands" width="7%" textAlign="Left"></e-column>
            <e-column
              field="userProfile.userFullName"
              width="17%"
              headerText="Name"
              textAlign="Left"
            ></e-column>
            <e-column field="userName" width="25%" headerText="Email" textAlign="Left"></e-column>
            <e-column
              field="memberShip.approvedDate"
              width="12%"
              headerText="Approved Date"
              textAlign="Left"
              format="MMM dd, yyyy"
              type="date"
            ></e-column>
            <e-column
              field="lastActivityDate"
              width="12%"
              headerText="Last Activity Date"
              textAlign="Left"
              format="MMM dd, yyyy"
              type="date"
            ></e-column>
            <e-column
              headerText="Permissions"
              textAlign="Left"
              field="usersInRoles"
              width="15%"
              :valueAccessor="userPermission"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div id="sccInactiveUsers" style="display: none">
        <ejs-grid
          :dataSource="sccInActiveUserList"
          ref="refSCCInactiveUserList"
          :created="created"
          :selection-settings="selectionOptions"
          :commandClick="inactiveUserCommandClick"
          :allowSorting="true"
          :allowPaging="true"
          :pageSettings="inactiveUserpageSettings"
          :toolbar="toolbarOptions"
        >
          <e-columns>
            <e-column
              field="userId"
              headerText="User ID"
              textAlign="Left"
              :isPrimaryKey="true"
              width="0"
            ></e-column>
            <e-column
              headerText="Edit"
              width="13%"
              :commands="inactiveUserCommands"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.userFullName"
              width="12%"
              headerText="Name"
              textAlign="Left"
            ></e-column>
            <e-column field="userName" width="22%" headerText="Email" textAlign="Left"></e-column>
            <e-column
              field="memberShip.approvedDate"
              width="12%"
              headerText="Inactive Date"
              textAlign="Left"
              format="MMM dd, yyyy"
              type="date"
            ></e-column>
            <e-column
              headerText="Permissions"
              textAlign="Left"
              field="usersInRoles"
              width="14%"
              :valueAccessor="inactiveUserPermission"
            ></e-column>
            <e-column
              field="lastActivityDate"
              width="12%"
              headerText="Last Activity Date"
              textAlign="Left"
              format="MMM dd, yyyy"
              type="date"
            ></e-column>
            <e-column
              field="userProfile.lastUpdateUser"
              headerText="Created By"
              textAlign="Left"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div id="sccHistoricalInformation" style="display: none">
        <ejs-grid
          :dataSource="sccUserEvenLogs()"
          ref="refSCCHistoricalInfoList"
          :created="created"
          enablePersistence="true"
          :selection-settings="selectionOptions"
          :allowSorting="true"
          :allowPaging="true"
          :pageSettings="historicalInfoPageSettings"
          :toolbar="toolbarOptions"
        >
          <e-columns>
            <e-column
              field="userId"
              headerText="User ID"
              textAlign="Left"
              :isPrimaryKey="true"
              width="0"
            ></e-column>
            <e-column field="userFullName" headerText="Name" textAlign="Left"></e-column>
            <e-column field="userName" headerText="Email" textAlign="Left"></e-column>
            <e-column field="eventType" headerText="Action Updated" textAlign="Left"></e-column>
            <e-column field="" headerText="Permission Changed" textAlign="Left"></e-column>
            <e-column
              field="logDate"
              headerText="Date Action Updated"
              textAlign="Left"
              type="date"
              format="MMM dd, yyyy"
            ></e-column>
            <e-column headerText="Updated User" textAlign="Left" field="updateUserName"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div id="sccLockedUsers" style="display: none">
        <ejs-grid
          :dataSource="sccLockedUserList"
          ref="refSCCLockedUserList"
          :created="created"
          :selection-settings="selectionOptions"
          :commandClick="lockedUserCommandClick"
          :allowSorting="true"
          :allowPaging="true"
          :pageSettings="inactiveUserpageSettings"
          :toolbar="toolbarOptions"
        >
          <e-columns>
            <e-column
              field="userId"
              headerText="User ID"
              textAlign="Left"
              :isPrimaryKey="true"
              width="0"
            ></e-column>
            <e-column
              headerText="Edit"
              width="13%"
              :commands="lockedUserCommands"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.userFullName"
              width="12%"
              headerText="Name"
              textAlign="Left"
            ></e-column>
            <e-column field="userName" width="22%" headerText="Email" textAlign="Left"></e-column>
            <e-column
              field="memberShip.approvedDate"
              width="12%"
              headerText="Inactive Date"
              textAlign="Left"
              format="MMM dd, yyyy"
              type="date"
            ></e-column>
            <e-column
              headerText="Permissions"
              textAlign="Left"
              field="usersInRoles"
              width="14%"
              :valueAccessor="inactiveUserPermission"
            ></e-column>
            <e-column
              field="lastActivityDate"
              width="12%"
              headerText="Last Activity Date"
              textAlign="Left"
              format="MMM dd, yyyy"
              type="date"
            ></e-column>
            <e-column
              field="userProfile.lastUpdateUser"
              headerText="Created By"
              textAlign="Left"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div style="margin: -12px">
        <div tabindex="0" id="basic">
          <div class="e-card-content">
            <ejs-tab
              id="sccUser_tab"
              class="e-background"
              ref="refSCCUserTabInstance"
              :selecting="tabSelect"
              :selected="tabSelected"
              :created="tabCreated"
            >
              <e-tabitems>
                <e-tabitem :header="headerText0" :content="content0"></e-tabitem>
                <e-tabitem :header="headerText1" :content="content1"></e-tabitem>
                <e-tabitem :header="headerText2" :content="content2"></e-tabitem>
                <e-tabitem :header="headerText3" :content="content3"></e-tabitem>
              </e-tabitems>
            </ejs-tab>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from "@syncfusion/ej2-vue-grids";
import { TabPlugin } from "@syncfusion/ej2-vue-navigations";

import {
  FETCH_SCC_USERS, FETCH_SCC_USERS_EVENT_LOG, ACTIVATE_USER, UNLOCK_USER,
} from "../store";

Vue.use(GridPlugin);
Vue.use(TabPlugin);

export default {
  name: "Users",
  created() {
    // this.sccUsers();
    // this.sccUserEventLogs();
  },
  data() {
    return {
      headerText0: { text: "Active Users" },
      headerText1: { text: "Inactive Users" },
      headerText2: { text: "Locked Users" },
      headerText3: { text: "Historical Information" },
      content0: "#sccActiveUsers",
      content1: "#sccInactiveUsers",
      content2: "#sccLockedUsers",
      content3: "#sccHistoricalInformation",
      sccUserList: [],
      sccInActiveUserList: [],
      sccUserHistories: [],
      sccLockedUserList: [],
      selectionOptions: {
        type: "Single",
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      toolbarOptions: ["Search"],
      activeUserpageSettings: { pageSize: 10 },
      inactiveUserpageSettings: { pageSize: 10 },
      historicalInfoPageSettings: { pageSize: 10 },
      commands: [
        {
          type: "Edit",
          buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
        },
      ],
      inactiveUserCommands: [{ buttonOption: { content: "Activate", cssClass: "e-info" } }],
      lockedUserCommands: [{ buttonOption: { content: "Unlock", cssClass: "e-info" } }],
    };
  },
  unmount() {},
  beforeDestroy() {
    this.$refs.refSCCActiveUserList.ej2Instances.searchSettings.key = "";
  },
  mounted() {
    // this.$refs.refSCCUserTabInstance.ej2Instances.animation.previous.effect = "FadeIn";
    // this.$refs.refSCCUserTabInstance.ej2Instances.animation.next.effect = "FadeIn";
  },
  computed: {
    // sccUserList() {
    //   return this.$store.getters.sccUserList;
    // },
  },
  methods: {
    created() {
      if (this.$refs.refSCCActiveUserList) {
        const refSCCActiveUserListSearchbar = document.getElementById(
          `${this.$refs.refSCCActiveUserList.$el.id}_searchbar`,
        );
        if (refSCCActiveUserListSearchbar) {
          refSCCActiveUserListSearchbar.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refSCCActiveUserList.$el.id);
          });
        }
      }

      // Added clear button and its functionalities to Searchbar
      if (this.$refs.refSCCInactiveUserList) {
        const refSCCInactiveUserListSearchbar = document.getElementById(
          `${this.$refs.refSCCInactiveUserList.$el.id}_searchbar`,
        );
        if (refSCCInactiveUserListSearchbar) {
          refSCCInactiveUserListSearchbar.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refSCCInactiveUserList.$el.id);
          });
        }
      }

      // Added clear button and its functionalities to Searchbar
      if (this.$refs.refSCCHistoricalInfoList) {
        const refSCCHistoricalInfoListSearchbar = document.getElementById(
          `${this.$refs.refSCCHistoricalInfoList.$el.id}_searchbar`,
        );
        if (refSCCHistoricalInfoListSearchbar) {
          refSCCHistoricalInfoListSearchbar.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refSCCHistoricalInfoList.$el.id);
          });
        }
      }

      // Added clear button and its functionalities to Searchbar
      if (this.$refs.refSCCLockedUserList) {
        const refSCCLockedUserListSearchbar = document.getElementById(
          `${this.$refs.refSCCLockedUserList.$el.id}_searchbar`,
        );
        if (refSCCLockedUserListSearchbar) {
          refSCCLockedUserListSearchbar.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refSCCLockedUserList.$el.id);
          });
        }
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove("e-search-icon");
      clearBtnEle.classList.add("e-clear-icon");

      clearBtnEle.addEventListener("click", () => {
        e.target.value = "";
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount == 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value == "") {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async tabCreated() {
      const tabObj = this.$refs.refSCCUserTabInstance.ej2Instances;
      const tagId = tabObj.selectedID;
      if (tagId === "0") {
        await this.sccUsers();
      } else if (tagId === "1") {
        await this.sccUsers();
      } else if (tagId === "2") {
        await this.sccUsers();
      } else if (tagId === "3") {
        await this.$store.dispatch(FETCH_SCC_USERS_EVENT_LOG);
      }
    },
    async tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    async tabSelected(e) {
      const tagId = e.selectedIndex;
      if (tagId === 0) {
        await this.sccUsers();
      } else if (tagId === 1) {
        await this.sccUsers();
      } else if (tagId === 2) {
        await this.sccUsers();
      } else if (tagId === 3) {
        await this.$store.dispatch(FETCH_SCC_USERS_EVENT_LOG);
      }
    },
    async sccUsers() {
      // this.$parent.notificationToasts.length = 0;
      try {
        await this.$store.dispatch(FETCH_SCC_USERS).then((resp) => {
          if (resp.status === 200) {
            const { data } = resp;
            const activeUsers = [];
            const inactiveUsers = [];
            const lockedUsers = [];
            for (let i = 0; i < data.length; i += 1) {
              if (data[i].memberShip.isLockedOut) {
                lockedUsers.push(data[i]);
              } else if (data[i].memberShip.isApproved) {
                activeUsers.push(data[i]);
              } else {
                inactiveUsers.push(data[i]);
              }
            }
            this.sccUserList = activeUsers;
            this.sccInActiveUserList = inactiveUsers;
            this.sccLockedUserList = lockedUsers;
          }
        });
      } catch (err) {
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: "Sorry, Something went wrong. Please try again later.",
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    sccUserEvenLogs() {
      return this.$store.getters.sccUserEventLogList;
    },
    // async sccUserEventLogs() {
    //   // this.$parent.notificationToasts.length = 0;
    //   try {
    //     await this.$store.dispatch(FETCH_SCC_USERS_EVENT_LOG);
    //     // .then((resp) => {
    //     //   if (resp.status === 200) {
    //     //     this.sccUserHistories = resp.data;
    //     //     // this.$refs.refSCCHistoricalInfoList.dataSource = resp.data;
    //     //   }
    //     //   // e.updateData(this.$store.getters.melissaAddresses);
    //     // });
    //   } catch (err) {
    //     this.$parent.notificationToasts.push({
    //       title: 'Error!',
    //       content: 'Sorry, Something went wrong. Please try again later.',
    //       cssClass: 'e-toast-danger',
    //       timeOut: 5000,
    //     });
    //   }
    //   if (this.$parent.notificationToasts.length > 0) {
    //     this.$parent.$refs.notifierRef.show();
    //   }
    // },
    userPermission(field, sccUserList) {
      return sccUserList[field].map((s) => s.role.roleName).join(",");
    },
    inactiveUserPermission(field, sccUserList) {
      return sccUserList[field].map((s) => s.role.roleName).join(",");
    },
    async activeUserCommandClick(args) {
      if (args.commandColumn.type === "Edit") {
        this.$router.push(`/manage-scc-user/${args.rowData.userId}`);
      }
    },
    async inactiveUserCommandClick(args) {
      // this.$parent.notificationToasts.length = 0;
      const { userName } = args.rowData;
      try {
        await this.$store.dispatch(ACTIVATE_USER, { userName }).then((resp) => {
          if (resp.status === 200) {
            this.sccUsers();
            this.$parent.notificationToasts.push({
              title: "Success!",
              content: "User activate successfully. Please check active user tab.",
              cssClass: "e-toast-success",
              timeOut: 5000,
            });
          }
          // e.updateData(this.$store.getters.melissaAddresses);
        });
      } catch (err) {
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: "Sorry, Something went wrong. Please try again later.",
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    async lockedUserCommandClick(args) {
      // this.$parent.notificationToasts.length = 0;
      const { userName } = args.rowData;
      try {
        await this.$store.dispatch(UNLOCK_USER, { userName }).then((resp) => {
          if (resp.status === 200) {
            this.sccUsers();
            this.$parent.notificationToasts.push({
              title: "Success!",
              content: "User unlocked successfully. Please check active user tab.",
              cssClass: "e-toast-success",
              timeOut: 5000,
            });
          }
          // e.updateData(this.$store.getters.melissaAddresses);
        });
      } catch (err) {
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: "Sorry, Something went wrong. Please try again later.",
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    onAddNewSCCUserClick() {
      const userId = null;
      this.$router.push(`/manage-scc-user/${userId}`);
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>

<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
.wrap {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 20px 10px;
  width: 340px;
}
#loader {
  color: #008cff;
  height: 40px;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 30%;
}
.e-card-content {
  margin: 0% !important;
}
.e-content .e-item {
  font-size: 12px;
  margin: 10px;
  text-align: justify;
}
/* .container {
min-width: 350px;
margin: 0 10px;
} */

.info {
  margin: 10px;
  font-weight: bold;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
</style>
